import React, { useCallback, useEffect, useState } from "react";
import "./EventThankYouPage.css";
import verifyLogo from "../Payment-successful/image/verified-logo.png";
import logoImg from "../BookingHistory/img/logo-in-review.svg";
import logoImgRef from "../BookingHistory/img/review-imag.svg";
import { RiUserAddLine } from "react-icons/ri";
import { IoBagOutline } from "react-icons/io5";
import { FaPercent } from "react-icons/fa";
import InviteFriendModal from "../BookingHistory/customComp/InviteFriendModal";
import PartywittyOffers from "../Club-aboutus/custom-comp/PartywittyOffers";
// import Loginpopup from "../../Navbar/Loginmodal";
// import { useSearchParams } from "react-router-dom";

export default function EventThankYouPage() {
  // const [searchParams] = useSearchParams();
  // const reviewSubmittedCode = searchParams.get("code");

  const userdata = JSON.parse(localStorage.getItem("userData"));

  // const [showLoginPopup, setShowLoginPopup] = useState(false);
  const [showModalPopup, setShowModalPopup] = useState(false);

  // const handleLogin = useCallback((ud) => {
  //     if (ud) {
  //         localStorage.setItem("userData", JSON.stringify(ud));
  //         window.location.reload();
  //         setShowLoginPopup(false);
  //     }
  // }, []);

  // useEffect(() => {
  //     const userData = localStorage.getItem("userData");
  //     if (!userData) {
  //         setShowLoginPopup(true);
  //     }
  // }, []);

  return (
    <>
      {/* {showLoginPopup && <Loginpopup clbk={handleLogin} isbackendUrl={true} />} */}
      <div className="event-thank-you-container">
        {/* Review Section */}
        <div className="event-thank-you-review-card">
          <div className="event-thank-you-check-icon">
            <span className="event-thank-you-verify-logo">
              <img src={verifyLogo} alt="verify-logo" />
            </span>
          </div>
          <h2>Thanks For Your Review, {userdata?.name.split(" ")[0]}!</h2>
          <p>
            Your feedback helps other party planners — and us — get even better.
          </p>
        </div>

        {/* Refer & Earn */}

        <div className="partywitty-offers-section-wrapper">
          <PartywittyOffers />
        </div>

        <div className="d-flex">
          <button className="btn btn-tran">
            <span>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="25"
                viewBox="0 0 24 25"
                fill="none">
                <mask id="path-1-inside-1_202_39078" fill="white">
                  <path d="M19.59 12.3691L15 7.77914V10.2391L14.14 10.3691C9.83 10.9791 6.91 13.2391 5.24 16.6991C7.56 15.0591 10.44 14.2691 14 14.2691H15V16.9591M13 15.2891C8.53 15.4991 5.33 17.1091 3 20.3691C4 15.3691 7 10.3691 14 9.36914V5.36914L21 12.3691L14 19.3691V15.2691C13.67 15.2691 13.34 15.2791 13 15.2891Z" />
                </mask>
                <path
                  d="M19.59 12.3691L15 7.77914V10.2391L14.14 10.3691C9.83 10.9791 6.91 13.2391 5.24 16.6991C7.56 15.0591 10.44 14.2691 14 14.2691H15V16.9591M13 15.2891C8.53 15.4991 5.33 17.1091 3 20.3691C4 15.3691 7 10.3691 14 9.36914V5.36914L21 12.3691L14 19.3691V15.2691C13.67 15.2691 13.34 15.2791 13 15.2891Z"
                  fill="#4F4F4F"
                />
                <path
                  d="M13 15.2691H12V15.2891H13H14V15.2691H13ZM15 7.77914L16.4142 6.36493L13 2.95071V7.77914H15ZM15 10.2391L15.2989 12.2167L17 11.9595V10.2391H15ZM14.14 10.3691L14.4203 12.3494L14.4296 12.3481L14.4389 12.3467L14.14 10.3691ZM5.24 16.6991L3.43883 15.8298L0.0747396 22.7997L6.39447 18.3323L5.24 16.6991ZM15 14.2691H17V12.2691H15V14.2691ZM13 15.2891L12.9412 13.29L12.9237 13.2905L12.9061 13.2913L13 15.2891ZM3 20.3691L1.03884 19.9769L4.62713 21.5321L3 20.3691ZM14 9.36914L14.2828 11.349L16 11.1037V9.36914H14ZM14 5.36914L15.4142 3.95493L12 0.540714V5.36914H14ZM21 12.3691L22.4142 13.7834L23.8284 12.3691L22.4142 10.9549L21 12.3691ZM14 19.3691H12V24.1976L15.4142 20.7834L14 19.3691ZM14 15.2691H16V13.2691H14V15.2691ZM19.59 12.3691L21.0042 10.9549L16.4142 6.36493L15 7.77914L13.5858 9.19335L18.1758 13.7834L19.59 12.3691ZM15 7.77914H13V10.2391H15H17V7.77914H15ZM15 10.2391L14.7011 8.26161L13.8411 8.39161L14.14 10.3691L14.4389 12.3467L15.2989 12.2167L15 10.2391ZM14.14 10.3691L13.8597 8.38888C8.89646 9.09133 5.40196 11.7625 3.43883 15.8298L5.24 16.6991L7.04117 17.5685C8.41804 14.7158 10.7635 12.8669 14.4203 12.3494L14.14 10.3691ZM5.24 16.6991L6.39447 18.3323C8.29564 16.9884 10.7415 16.2691 14 16.2691V14.2691V12.2691C10.1385 12.2691 6.82436 13.1299 4.08553 15.066L5.24 16.6991ZM14 14.2691V16.2691H15V14.2691V12.2691H14V14.2691ZM15 14.2691H13V16.9591H15H17V14.2691H15ZM13 15.2891L12.9061 13.2913C7.91418 13.5259 4.10842 15.3788 1.37287 19.2062L3 20.3691L4.62713 21.5321C6.55157 18.8395 9.14582 17.4724 13.0939 17.2869L13 15.2891ZM3 20.3691L4.96116 20.7614C5.41429 18.4957 6.29864 16.3507 7.75515 14.6861C9.18184 13.0557 11.2439 11.7832 14.2828 11.349L14 9.36914L13.7172 7.38924C9.75614 7.9551 6.81816 9.68263 4.74485 12.0521C2.70136 14.3875 1.58571 17.2425 1.03884 19.9769L3 20.3691ZM14 9.36914H16V5.36914H14H12V9.36914H14ZM14 5.36914L12.5858 6.78335L19.5858 13.7834L21 12.3691L22.4142 10.9549L15.4142 3.95493L14 5.36914ZM21 12.3691L19.5858 10.9549L12.5858 17.9549L14 19.3691L15.4142 20.7834L22.4142 13.7834L21 12.3691ZM14 19.3691H16V15.2691H14H12V19.3691H14ZM14 15.2691V13.2691C13.635 13.2691 13.2743 13.2802 12.9412 13.29L13 15.2891L13.0588 17.2883C13.4057 17.2781 13.705 17.2691 14 17.2691V15.2691Z"
                  fill="#4F4F4F"
                  mask="url(#path-1-inside-1_202_39078)"
                />
              </svg>
            </span>
            Share with a Friends
          </button>
          <button className="btn btn-tran">
            <span>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="25"
                viewBox="0 0 24 25"
                fill="none">
                <mask id="path-1-inside-1_202_39078" fill="white">
                  <path d="M19.59 12.3691L15 7.77914V10.2391L14.14 10.3691C9.83 10.9791 6.91 13.2391 5.24 16.6991C7.56 15.0591 10.44 14.2691 14 14.2691H15V16.9591M13 15.2891C8.53 15.4991 5.33 17.1091 3 20.3691C4 15.3691 7 10.3691 14 9.36914V5.36914L21 12.3691L14 19.3691V15.2691C13.67 15.2691 13.34 15.2791 13 15.2891Z" />
                </mask>
                <path
                  d="M19.59 12.3691L15 7.77914V10.2391L14.14 10.3691C9.83 10.9791 6.91 13.2391 5.24 16.6991C7.56 15.0591 10.44 14.2691 14 14.2691H15V16.9591M13 15.2891C8.53 15.4991 5.33 17.1091 3 20.3691C4 15.3691 7 10.3691 14 9.36914V5.36914L21 12.3691L14 19.3691V15.2691C13.67 15.2691 13.34 15.2791 13 15.2891Z"
                  fill="#4F4F4F"
                />
                <path
                  d="M13 15.2691H12V15.2891H13H14V15.2691H13ZM15 7.77914L16.4142 6.36493L13 2.95071V7.77914H15ZM15 10.2391L15.2989 12.2167L17 11.9595V10.2391H15ZM14.14 10.3691L14.4203 12.3494L14.4296 12.3481L14.4389 12.3467L14.14 10.3691ZM5.24 16.6991L3.43883 15.8298L0.0747396 22.7997L6.39447 18.3323L5.24 16.6991ZM15 14.2691H17V12.2691H15V14.2691ZM13 15.2891L12.9412 13.29L12.9237 13.2905L12.9061 13.2913L13 15.2891ZM3 20.3691L1.03884 19.9769L4.62713 21.5321L3 20.3691ZM14 9.36914L14.2828 11.349L16 11.1037V9.36914H14ZM14 5.36914L15.4142 3.95493L12 0.540714V5.36914H14ZM21 12.3691L22.4142 13.7834L23.8284 12.3691L22.4142 10.9549L21 12.3691ZM14 19.3691H12V24.1976L15.4142 20.7834L14 19.3691ZM14 15.2691H16V13.2691H14V15.2691ZM19.59 12.3691L21.0042 10.9549L16.4142 6.36493L15 7.77914L13.5858 9.19335L18.1758 13.7834L19.59 12.3691ZM15 7.77914H13V10.2391H15H17V7.77914H15ZM15 10.2391L14.7011 8.26161L13.8411 8.39161L14.14 10.3691L14.4389 12.3467L15.2989 12.2167L15 10.2391ZM14.14 10.3691L13.8597 8.38888C8.89646 9.09133 5.40196 11.7625 3.43883 15.8298L5.24 16.6991L7.04117 17.5685C8.41804 14.7158 10.7635 12.8669 14.4203 12.3494L14.14 10.3691ZM5.24 16.6991L6.39447 18.3323C8.29564 16.9884 10.7415 16.2691 14 16.2691V14.2691V12.2691C10.1385 12.2691 6.82436 13.1299 4.08553 15.066L5.24 16.6991ZM14 14.2691V16.2691H15V14.2691V12.2691H14V14.2691ZM15 14.2691H13V16.9591H15H17V14.2691H15ZM13 15.2891L12.9061 13.2913C7.91418 13.5259 4.10842 15.3788 1.37287 19.2062L3 20.3691L4.62713 21.5321C6.55157 18.8395 9.14582 17.4724 13.0939 17.2869L13 15.2891ZM3 20.3691L4.96116 20.7614C5.41429 18.4957 6.29864 16.3507 7.75515 14.6861C9.18184 13.0557 11.2439 11.7832 14.2828 11.349L14 9.36914L13.7172 7.38924C9.75614 7.9551 6.81816 9.68263 4.74485 12.0521C2.70136 14.3875 1.58571 17.2425 1.03884 19.9769L3 20.3691ZM14 9.36914H16V5.36914H14H12V9.36914H14ZM14 5.36914L12.5858 6.78335L19.5858 13.7834L21 12.3691L22.4142 10.9549L15.4142 3.95493L14 5.36914ZM21 12.3691L19.5858 10.9549L12.5858 17.9549L14 19.3691L15.4142 20.7834L22.4142 13.7834L21 12.3691ZM14 19.3691H16V15.2691H14H12V19.3691H14ZM14 15.2691V13.2691C13.635 13.2691 13.2743 13.2802 12.9412 13.29L13 15.2891L13.0588 17.2883C13.4057 17.2781 13.705 17.2691 14 17.2691V15.2691Z"
                  fill="#4F4F4F"
                  mask="url(#path-1-inside-1_202_39078)"
                />
              </svg>
            </span>
            Posted on a Feed
          </button>
        </div>
      </div>
      <InviteFriendModal
        isOpen={showModalPopup}
        onClose={() => setShowModalPopup(false)}
      />
    </>
  );
}
